// extracted by mini-css-extract-plugin
module.exports = {"products":"Products_products__JW70t","pageInfo":"Products_pageInfo__2o0k6","productsFig":"Products_productsFig__1Gn7_","greenBtn":"Products_greenBtn__3LCqO"};